import { Form, Input } from "antd";
import { getConfigAppPartType } from "@lhd/features/Apps/utils";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Styles } from "./styled";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";

interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  namePath?: string | string[];
  styleColor?: React.CSSProperties;
}

const Text = (props: IProps) => {
  const { item, style, namePath, styleColor = {} } = props;
  const form = Form.useFormInstance();

  getConfigAppPartType(item);

  return (
    <Styles style={style}>
      <Form.Item name={namePath} rules={getRuleValidation(item)}>
        <Input
          style={styleColor}
          onPressEnter={(e) => e.preventDefault()}
          onBlur={(e) => {
            const value = e.target.value;
            const trimmedValue = value.trim();

            if (namePath && value !== trimmedValue) {
              form.setFieldValue(namePath, trimmedValue);
            }
          }}
        />
      </Form.Item>
    </Styles>
  );
};

export default Text;
